export const formatFileSize = (sizeInBytes: number): string => {
  if (!sizeInBytes || sizeInBytes <= 0) return "0.00 KB";

  const sizeInMB = sizeInBytes / (1024 * 1024);
  if (sizeInMB >= 1) {
    return `${sizeInMB.toFixed(2)} MB`;
  }

  const sizeInKB = sizeInBytes / 1024;
  return `${sizeInKB.toFixed(2)} KB`;
};

export const resolveContentType = (raw: string | undefined): string => {
  if (raw === "application/pdf") return "application/pdf";
  if (!raw) return "octet-stream";
  return raw.includes("/") ? raw.split("/")[1] : raw;
};

export const normalizeFileName = (name: string) => {
  let cleaned = name.trim();
  cleaned = cleaned.replace(/\s+/g, "-");
  return cleaned;
};